import type { V2CreateAdminSocietyInput } from '@idc-forms/schemas/api-v2/admin-societies'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateSocietyV2Mutation } from '../hooks/use-society-v2-mutations'
import { SocietyV2Form } from './society-v2-form'

type SocietyV2CreatePanelProps = {
  onDone?: () => void
}

/** "Nueva sociedad" contra la API v2: el mismo `SocietyV2Form` que la edición. */
export function SocietyV2CreatePanel({ onDone }: SocietyV2CreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateSocietyV2Mutation()
  const done = onDone ?? closePanel

  return (
    <SocietyV2Form
      mode="create"
      submitLabel="Crear sociedad"
      pending={createMutation.isPending}
      onSubmit={(values) => {
        // En modo create el resolver exige las tres credenciales, así que están
        // presentes en runtime aunque el tipo del form las declare opcionales.
        createMutation.mutate(values as V2CreateAdminSocietyInput, {
          onSuccess: () => {
            done()
          }
        })
      }}
      onCancel={done}
    />
  )
}
